import _pick from 'lodash/pick';
import * as types from './actionTypes';
import orderApi from './api';
import cartApi from '../cart/api';
import * as cartActions from '../cart/actions';
import { setIsStockReapplied } from '../stock/actions';
import { plainPhoneNumber } from '../../../utils/telephone';
import { clearRestaurantStopList, fetchStopList } from '../restaurant/actions';
import { initGooglePay } from '../payTypes/actions';
import { setError } from '../errors/actions';
import config from '../../../config';

export const fetchOrderList = (page = 1) => {
  return dispatch => {
    dispatch({ type: types.FETCH_LIST_REQUEST, payload: page });

    return orderApi
      .getList(page)
      .then(data => {
        return dispatch({ type: types.FETCH_LIST_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_LIST_FAILURE, payload: message });
      });
  };
};

export const fetchOrderListIsNeeded = () => {
  return (dispatch, getState) => {
    const {
      order: { isLoading, isLoaded },
      user: { isAuthenticated },
    } = getState();

    return isAuthenticated && !isLoading && !isLoaded ? dispatch(fetchOrderList()) : false;
  };
};

export const fetchOrderListNextPage = () => {
  return (dispatch, getState) => {
    const {
      order: { currentPage },
    } = getState();

    dispatch({ type: types.FETCH_ORDER_LIST_NEXT_PAGE_REQUEST, payload: currentPage + 1 });

    return orderApi
      .getList(currentPage + 1)
      .then(data => {
        return dispatch({ type: types.FETCH_ORDER_LIST_NEXT_PAGE_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_ORDER_LIST_NEXT_PAGE_FAILURE, payload: message });
      });
  };
};

export const setOrderRating = ({ rate, order_id }) => {
  return dispatch => {
    dispatch({ type: types.SET_ORDER_RATING_REQUEST });

    return orderApi
      .setOrderRating({ rate, order_id, comment: '', shortcuts: [] })
      .then(() => {
        return dispatch({ type: types.SET_ORDER_RATING_SUCCESS, payload: { rate, order_id } });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.SET_ORDER_RATING_FAILURE, payload: message });
      });
  };
};

export const addToCart = (id, composition) => {
  return dispatch => {
    dispatch({ type: types.ADD_TO_CART_REQUEST, payload: id });

    return cartApi
      .addToCart(composition)
      .then(data => {
        dispatch({ type: types.ADD_TO_CART_SUCCESS, payload: id });
        // Не учитывать в аналитике добавление товаров в корзину после выполнения "Повтора заказа"
        return dispatch(cartActions.addToCartDone({ ...data, withoutAnalytic: true }));
      })
      .catch(({ message }) => {
        return { type: types.ADD_TO_CART_FAILURE, payload: { id, error: message } };
      });
  };
};

// CHECKOUT

/**
 * Устанавливаем user_data
 * @param {object} payload
 */
export const setCheckoutUserData = payload => ({ type: types.SET_CHECKOUT_USER_DATA, payload });

/**
 * Устанавливаем deliveryType
 * @param {boolean} payload
 */
export const setCheckoutDeliveryType = payload => {
  return (dispatch, getState) => {
    const {
      deliveryAddress,
      pickupRestaurant,
      previousIsContactFreeDelivery,
    } = getState().order.checkout;

    if (payload === 'delivery') {
      dispatch(setCheckoutContactFreeDelivery(previousIsContactFreeDelivery));
    } else if (payload === 'pickup') {
      dispatch(setCheckoutContactFreeDelivery(false));
    }

    if (payload === 'delivery' && (deliveryAddress.address_id || deliveryAddress.address_in_line)) {
      dispatch(fetchDeliveryRestaurantDetails(deliveryAddress));
    } else if (payload === 'pickup' && pickupRestaurant) {
      dispatch(setPickupRestaurantDetails(pickupRestaurant));
    } else {
      dispatch(resetCheckoutField('currentRestaurant'));
      dispatch(resetCheckoutField('intervals'));
      dispatch(resetCheckoutField('deliveryTime'));
      // инициализируем гугл пей (параметр приходит в ресторане)
      dispatch(initGooglePay(false));
      //
      dispatch(clearRestaurantStopList());
    }

    return dispatch({ type: types.SET_CHECKOUT_DELIVERY_TYPE, payload });
  };
};

/**
 * Устанавливаем текущий лоялти another_bonuses/pickup_bonuses
 * @param {string} payload
 */
export const setCheckoutBonusesType = payload => ({
  type: types.SET_CHECKOUT_BONUSES_TYPE,
  payload,
});

/**
 * Устанавливаем тип времени доставки instantly: "как можно скорее" или intime: "ко времени"
 * @param {string} payload
 */
export const setCheckoutDeliveryTimeType = payload => ({
  type: types.SET_CHECKOUT_DELIVERY_TIME_TYPE,
  payload,
});

/**
 * Устанавливаем время доставки
 * @param {string} payload
 */
export const setCheckoutDeliveryTime = payload => ({
  type: types.SET_CHECKOUT_DELIVERY_TIME,
  payload,
});

/**
 * Устанавливаем тип оплаты payType (cash/card_to_courier/online)
 * @param {string} payload
 */
export const setCheckoutPayType = payload => ({ type: types.SET_CHECKOUT_PAY_TYPE, payload });

/**
 * Вводим значение сдачи change
 * @param {number} payload
 */
export function setCheckoutChange(payload) {
  return { type: types.SET_CHECKOUT_CHANGE, payload };
}

/**
 * Ставим чекбокс сохранить карту или нет
 * @param {number} payload
 */
export function setCheckoutIsCardSaved(payload) {
  return { type: types.SET_CHECKOUT_IS_CARD_SAVED, payload };
}

/**
 * Переключаем значение isContactFreeDelivery
 * @param {boolean} payload
 */
export function setCheckoutContactFreeDelivery(payload) {
  return { type: types.SET_CHECKOUT_CONTACT_FREE_DELIVERY, payload };
}

/**
 * Устанавливаем примечание для курьера
 * @param {string} payload
 */
export const setCheckoutDescription = payload => ({
  type: types.SET_CHECKOUT_DESCRIPTION,
  payload,
});

// запрашиваем детали ресторана по адресу для доставки, на входе {address_in_line, flat, floor, porch, intercom}
export const setCheckoutDeliveryAddress = params => ({
  type: types.SET_CHECKOUT_DELIVERY_ADDRESS,
  payload: params,
});

//
export const fetchRestaurantIntervals = params => {
  return dispatch => {
    dispatch({ type: types.FETCH_RESTAURANT_INTERVALS_REQUEST });

    // сбрасываем выбранное время
    dispatch(resetCheckoutField('deliveryTime'));

    return orderApi
      .getIntervals(params)
      .then(payload => {
        return dispatch({ type: types.FETCH_RESTAURANT_INTERVALS_SUCCESS, payload });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_RESTAURANT_INTERVALS_FAILURE, payload: message });
      });
  };
};

// запрашиваем детали ресторана по адресу для доставки, на входе {address_in_line, flat, floor, porch, intercom}
export const fetchDeliveryRestaurantDetails = (address, onSuccessCallback) => {
  return (dispatch, getState) => {
    dispatch({ type: types.FETCH_DELIVERY_RESTAURANT_DETAILS_REQUEST });

    const args = address.address_id
      ? { address_id: address.address_id }
      : { address: address.address_in_line };

    return orderApi
      .getRestaurantDetails(args)
      .then(data => {
        if (getState().stock.data?.code) {
          dispatch(setIsStockReapplied(false));
        }

        // инициализируем гугл пей (параметр приходит в ресторане)
        dispatch(initGooglePay(data.google_pay));
        // подтягиваем стоплисты для ресторана
        dispatch(fetchStopList(data.id));
        // запрашиваем интервалы доставки при выборе ресторана
        dispatch(fetchRestaurantIntervals(args));
        //
        if (onSuccessCallback) {
          onSuccessCallback();
        }

        return dispatch({
          type: types.FETCH_DELIVERY_RESTAURANT_DETAILS_SUCCESS,
          payload: data,
          analytAddress: address.address_in_line,
        });
      })
      .catch(({ message }) => {
        return dispatch({
          type: types.FETCH_DELIVERY_RESTAURANT_DETAILS_FAILURE,
          payload: message,
          analytAddress: address.address_in_line,
        });
      });
  };
};

export const setPickupRestaurantDetails = restaurant => {
  return dispatch => {
    // инициализируем гугл пей (параметр приходит в ресторане)
    dispatch(initGooglePay(restaurant.google_pay));
    // подтягиваем стоплисты для ресторана
    dispatch(fetchStopList(restaurant.id));
    // запрашиваем интервалы доставки при выборе ресторана
    dispatch(fetchRestaurantIntervals({ restaurant_id: restaurant.id }));

    return dispatch({
      type: types.SET_PICKUP_RESTAURANT_DETAILS,
      payload: restaurant,
    });
  };
};

export const setRestaurantDetailsWithoutTime = () => {
  return (dispatch, getState) => {
    const { pickupRestaurant, deliveryRestaurant, deliveryType } = getState().order.checkout;
    const currentRestaurant = deliveryType === 'pickup' ? pickupRestaurant : deliveryRestaurant;

    // инициализируем гугл пей (параметр приходит в ресторане)
    dispatch(initGooglePay(currentRestaurant.google_pay));
    // подтягиваем стоплисты для ресторана
    dispatch(fetchStopList(currentRestaurant.id));

    return dispatch({
      type: types.SET_RESTAURANT_DETAILS_WITHOUT_TIME,
      payload: currentRestaurant,
    });
  };
};

// запрашиваем детали ресторана по id ресторана для самовывоза, на входе restaurant_id и wanted_time
export const fetchRestaurantDetailsWithTime = wantedTime => {
  return (dispatch, getState) => {
    const { deliveryAddress, pickupRestaurant, deliveryType } = getState().order.checkout;

    dispatch({ type: types.FETCH_RESTAURANT_DETAILS_WITH_TIME_REQUEST });

    const args = deliveryAddress.address_id
      ? { address_id: deliveryAddress.address_id }
      : { address: deliveryAddress.address_in_line };

    const params =
      deliveryType === 'pickup'
        ? { wanted_time: wantedTime, restaurant_id: pickupRestaurant.id }
        : { ...args, wanted_time: wantedTime };

    return orderApi
      .getRestaurantDetails(params)
      .then(data => {
        if (getState().stock.data?.code) {
          dispatch(setIsStockReapplied(false));
        }

        // инициализируем гугл пей (параметр приходит в ресторане)
        dispatch(initGooglePay(data.google_pay));
        // подтягиваем стоплисты для ресторана
        dispatch(fetchStopList(data.id));

        return dispatch({
          type: types.FETCH_RESTAURANT_DETAILS_WITH_TIME_SUCCESS,
          payload: data,
        });
      })
      .catch(({ message }) => {
        return dispatch({
          type: types.FETCH_RESTAURANT_DETAILS_WITH_TIME_FAILURE,
          payload: message,
        });
      });
  };
};

export const setLocalStorageCheckout = params => {
  return (_, getState) => {
    const localStorageCheckout = {
      value: { ...getState().order.checkout, ...params },
      timestamp: new Date().getTime(),
    };

    window.localStorage.setItem('checkout', JSON.stringify(localStorageCheckout));
  };
};

export const removeLocalStorageCheckout = () => {
  window.localStorage.removeItem('checkout');
};

export const getLocalStorageCheckout = () => {
  return (dispatch, getState) => {
    const city_id = getState().city.userCity.id;
    const checkout = JSON.parse(window.localStorage.getItem('checkout'));

    if (!checkout) {
      dispatch({ type: types.GET_LOCAL_STORAGE_CHECKOUT_REQUEST });
      return;
    }

    async function fetchRestaurantDetails() {
      // если промежуток меньше 10 минут, то все норм
      if ((new Date().getTime() - checkout.timestamp) / 1000 >= 600) {
        removeLocalStorageCheckout();
        return;
      }

      const checkoutFields = _pick(checkout.value, [
        'user_data',
        'deliveryType',
        'deliveryTimeType',
        'payType',
        'change',
        'isContactFreeDelivery',
        'previousIsContactFreeDelivery',
        'description',
      ]);

      // проверяем, есть ли выбранное время доставки
      const wanted_time =
        checkout.value.deliveryTimeType === 'intime' && checkout.value.deliveryTime.hoursMinutes
          ? `${checkout.value.deliveryTime.day} ${checkout.value.deliveryTime.hoursMinutes}`
          : undefined;

      // если есть, то назначаем его
      if (wanted_time) {
        checkoutFields.deliveryTime = checkout.value.deliveryTime;
      }

      // для адреса доставки
      if (
        checkout.value.deliveryAddress.address_id ||
        checkout.value.deliveryAddress.address_in_line
      ) {
        const addressArgs = checkout.value.deliveryAddress.address_id
          ? { address_id: checkout.value.deliveryAddress.address_id }
          : { address: checkout.value.deliveryAddress.address_in_line };

        try {
          let restaurantData;
          if (checkoutFields.deliveryType === 'delivery' && wanted_time) {
            restaurantData = await orderApi.getRestaurantDetails({
              ...addressArgs,
              wanted_time,
              withError: false,
            });
          } else {
            restaurantData = await orderApi.getRestaurantDetails({
              ...addressArgs,
              withError: false,
            });
          }

          // если город тот же самый, то подставляем ресторан доставки и адрес доставки
          if (restaurantData.city_id === city_id) {
            checkoutFields.deliveryRestaurant = restaurantData;
            checkoutFields.deliveryAddress = checkout.value.deliveryAddress;
          }
        } catch {
          console.warn('localStorage error');
        }
      }

      // для адреса самовывоза
      if (checkout.value.pickupRestaurant) {
        try {
          let restaurantData;

          if (checkoutFields.deliveryType === 'pickup' && wanted_time) {
            restaurantData = await orderApi.getRestaurantDetails({
              restaurant_id: checkout.value.pickupRestaurant.id,
              wanted_time,
              withError: false,
            });
          } else {
            restaurantData = checkout.value.pickupRestaurant;
          }

          // если мы не меняли город
          if (restaurantData.city_id === city_id) {
            checkoutFields.pickupRestaurant = restaurantData;
          }
        } catch {
          console.warn('localStorage error');
        }
      }

      if (checkoutFields.deliveryType === 'delivery' && checkoutFields.deliveryRestaurant) {
        checkoutFields.currentRestaurant = checkoutFields.deliveryRestaurant;
        const addressArgs = checkoutFields.deliveryAddress.address_id
          ? { address_id: checkoutFields.deliveryAddress.address_id }
          : { address: checkoutFields.deliveryAddress.address_in_line };

        // интервалы
        dispatch(fetchRestaurantIntervals(addressArgs));
      } else if (checkoutFields.deliveryType === 'pickup' && checkoutFields.pickupRestaurant) {
        checkoutFields.currentRestaurant = checkoutFields.pickupRestaurant;
        // интервалы
        dispatch(fetchRestaurantIntervals({ restaurant_id: checkoutFields.pickupRestaurant.id }));
      }

      if (checkoutFields.currentRestaurant) {
        // стоплисты
        dispatch(fetchStopList(checkoutFields.currentRestaurant.id));
        // инициализируем гугл пей (параметр приходит в ресторане)
        // await чтобы гугол пей инициализировался вместе со всеми остальными типами оплаты
        await dispatch(initGooglePay(checkoutFields.currentRestaurant.google_pay));
      }

      dispatch({ type: types.GET_LOCAL_STORAGE_CHECKOUT_SUCCESS, payload: checkoutFields });
    }

    fetchRestaurantDetails();
  };
};

/**
 * Устанавливаем isPayed после онлайн оплаты
 * @param {boolean} payload
 */
export const setCheckoutIsPayed = () => ({
  type: types.SET_CHECKOUT_IS_PAYED,
});

export const payOrder = (params = {}, callback) => {
  return (dispatch, getState) => {
    const {
      card: { cardSelect },
      user: { isAuthenticated, profile },
      cart: { sailplay_discount },
      sailplay: { usedBonuses },
      order: {
        checkout: {
          user_data,
          deliveryType,
          deliveryAddress,
          deliveryTimeType,
          deliveryTime,
          payType,
          change,
          isCardSaved,
          isContactFreeDelivery,
          description,
          currentRestaurant,
        },
      },
    } = getState();

    dispatch({ type: types.PAY_REQUEST });

    if (!isAuthenticated) {
      user_data.phone = plainPhoneNumber(user_data.phone);
    }

    const pay_type =
      payType === 'online' && currentRestaurant?.pay_params?.online_pay_system === 5
        ? 'online_payu'
        : payType;

    // если введена новая карта или карты вообще нет
    const cloudpayments_data =
      cardSelect.cardId === -1 || cardSelect.cardId === null
        ? { is_token: 0, card_cryptogram_packet: cardSelect.cryptogram, name: cardSelect.cpName }
        : { is_token: 1, card_id: cardSelect.cardId };

    const newParams = {
      ...(isAuthenticated ? { user_id: profile?.id } : { user_data: user_data }),
      address_json:
        deliveryType === 'delivery' && !deliveryAddress.address_id ? deliveryAddress : undefined,
      address_id:
        deliveryType === 'delivery' && deliveryAddress.address_id
          ? deliveryAddress.address_id
          : undefined,
      restaurant_id: deliveryType === 'pickup' ? currentRestaurant?.id : undefined,
      wanted_time:
        deliveryTimeType === 'intime'
          ? `${deliveryTime.day} ${deliveryTime.hoursMinutes}`
          : undefined,
      pay_type,
      change: change && pay_type === 'cash' ? change : undefined,
      cloudpayments_data: pay_type === 'online' ? cloudpayments_data : undefined,
      description: `${
        // eslint-disable-next-line no-nested-ternary
        isContactFreeDelivery
          ? config.legal === 'pl'
            ? 'CONTACT-FREE DELIVERY; '
            : 'БЕСКОНТАКТНАЯ ДОСТАВКА; '
          : ''
      }${description}`,
      save_card:
        pay_type === 'online_payu'
          ? params.save_card
          : pay_type === 'online' && (cardSelect.cardId === -1 || cardSelect.cardId === null)
            ? isCardSaved
            : undefined,
      payu_token: pay_type === 'online_payu' ? params.payu_token : undefined,
      payu_card_id: pay_type === 'online_payu' ? params.payu_card_id : undefined,
      papabonus_charge: isAuthenticated ? sailplay_discount || 0 : undefined,
      ...params,
    };

    return orderApi
      .pay(newParams)
      .then(payload => {
        // это для Польши
        if (pay_type === 'online_payu' && payload?.payment?.redirect_url) {
          window.location.assign(payload.payment.redirect_url);
          return true;
        }

        if (payload.payment) {
          const { transaction_status, error } = payload.payment;

          // два варианта: либо транзакция успешная у online и googlePay, но внутри лежит acs_url, что значит
          // надо в колбеке вызвать модалку подтверждения оплаты (2+2)
          // либо просто завершение оплаты для applePay, там не бывает acs_url, поэтому ставится isPayed: true
          if (transaction_status) {
            callback?.(payload);
          } else {
            dispatch(setError(error));

            return dispatch({ type: types.PAY_FAILURE });
          }
        }

        return dispatch({
          type: types.PAY_SUCCESS,
          payload: {
            order_data: payload.order_data,
            order_id: payload.order_id,
            isPayed:
              !payload.payment || (!payload.payment.acs_url && payload.payment.transaction_status),
          },
        });
      })
      .catch(({ message }) => {
        if (callback) {
          callback(message);
        }

        return dispatch({ type: types.PAY_FAILURE });
      });
  };
};

/**
 * Сбрасываем order/checkout до начальных значений, кроме адресов
 */
export const resetCheckout = () => {
  removeLocalStorageCheckout();

  return { type: types.RESET_CHECKOUT };
};

/**
 * Сбрасываем order/checkout до начальных значений
 */
export const resetCheckoutField = field => ({ type: types.RESET_CHECKOUT_FIELD, payload: field });

/**
 * Сбрасываем order/checkout до начальных значений
 */
export const resetCheckoutPayment = () => ({ type: types.RESET_CHECKOUT_PAYMENT });

/**
 * Сбрасываем order до начальных значений
 */
export const resetOrderState = () => ({ type: types.RESET_ORDER_STATE });
